import React, {useContext, useEffect, useState} from 'react'
import Lottie from 'lottie-light-react'
import {
    Box,
    Checkbox,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Button as ButtonMui, Snackbar
} from '@mui/material'
import Button from '../button/Button.jsx'
import ButtonTimer from '../buttonTimer/ButtonTimer.jsx'
import ListHistory from './listHistory/ListHistory.jsx'
import Order from './order/Order.jsx'
import ServiceArea from './serviceArea/ServiceArea.jsx'
import OpeningHours from './openingHours/OpeningHours.jsx'
import ScheduledTimes from './scheduledTimes/ScheduledTimes.jsx'
import ListRoutes from './listRoutes/ListRoutes.jsx'
import ListFlavor from './listFlavor/ListFlavor.jsx'
import PaymentTypes from './paymentTypes/PaymentTypes.jsx'
import AddCard from './addCard/AddCard.jsx'
import Address from './address/Address.jsx'

import {
    getLocal,
    getSession,
    removeSession,
    setLocal,
    setSession,
    clearLocal,
    clearSession
} from '../../hooks/useStorage/useStorage.jsx'

import {
    checkUndefined,
    cleanTextToNumbers,
    isCNPJ,
    isCPF,
    isEmpty,
    isMobile,
    isPhone,
    maskCEP,
    maskCPF_CNPJ,
    maskInternationalPhone,
    capitalizeFirstLetter, isDebug
} from 'react-lf-tools'

import {
    general as textsGeneral,
    address as textsAddress,
    itemBag as textsItemBag,
    paymentMethods as textsPaymentMethods,
    shoppingCart as textsShoppingCart, addCard as textsAddCard
} from '../../translate/Translate.jsx'

import loading from '../../assets/loading.json'
import checked from '../../assets/checked.json'
import error from '../../assets/error.json'

import {
    AddRounded as AddIcon,
    CurrencyExchangeRounded,
    RemoveRounded as RemoveIcon,
    ArrowBackRounded as ArrowBackIcon,
    CheckCircleRounded as CheckCircleIcon,
    ExpandMoreRounded as ExpandIcon,
    Receipt,
    Discount,
    Schedule,
    Cancel,
    CreditCardRounded as CreditCardIcon,
    LocalAtmRounded as LocalAtmIcon,
    PointOfSaleRounded as PointOfSaleIcon,
    Pix, LogoutRounded
} from '@mui/icons-material'

import {ShoppingCartContext} from '../../context/ShoppingCartContext.jsx'
import {ItemBagContext} from '../../context/ItemBagContext.jsx'

import {textBodyColor, titleColor} from '../../metrics.module.scss'

import {motion} from 'framer-motion'

import moment from 'moment'

import {checkCityServiceArea} from '../../utils/utils.jsx'
import './dialogs.scss'

export const DialogLanguage = ({open, onClose}) => {
    const handleClickLanguage = (value) => {
        switch (value) {
            case 'english':
                setLocal('language', 'en')
                window.location.reload(false)
                break
            case 'spanish':
                setLocal('language', 'es')
                window.location.reload(false)
                break
            default:
                setLocal('language', 'pt')
                window.location.reload()
                break
        }
    }

    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsGeneral.language}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.chooseLanguage}
            </DialogContentText>
            <Button
                className={'button-dialog'}
                value={'portuguese'}
                title={textsGeneral.portuguese}
                onClick={handleClickLanguage}/>
            <Button
                className={'button-dialog'}
                value={'english'}
                title={textsGeneral.english}
                onClick={handleClickLanguage}/>
            <Button
                className={'button-dialog'}
                value={'spanish'}
                title={textsGeneral.spanish}
                onClick={handleClickLanguage}/>
        </DialogContent>
    </Dialog>
}

export const DialogConfirmation = ({open, onClose, onClick, title = '', message = '', yesNot = false, type}) => {
    const handleClose = _ => onClose(type)
    const handleClick = () => onClick(type)
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {message}
            </DialogContentText>
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={yesNot ? textsGeneral.no : textsGeneral.cancel}
                    onClick={handleClose}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={yesNot ? textsGeneral.yes : textsGeneral.confirm}
                    onClick={handleClick}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogWarning = ({open, onClick, title = '', message = ''}) => {
    const handleClick = (value) => onClick(value)
    return <Dialog open={open}>
        <DialogTitle>
            {title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {message}
            </DialogContentText>
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.toClose}
                    onClick={handleClick}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogCoupon = ({open, onClick, onClose, coupon, message}) => {
    const handleClick = () => onClick(coupon)
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsGeneral.discountCoupon}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {message}
            </DialogContentText>
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={textsGeneral.toClose}
                    onClick={onClose}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.rescue}
                    onClick={handleClick}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogEnterZipCode = ({open, onClick, onClose, notZipCode}) => {
    const [zipCode, setZipCode] = useState('')
    const [zipCodeRequired, setZipCodeRequired] = useState(getLocal('CEPNeeded'))
    const handleChange = e => {
        let cep = e.target.value
        cep = cleanTextToNumbers(cep)
        cep = maskCEP(cep)
        setZipCode(cep)
    }
    const confirm = () => {
        onClick(zipCode)
        setZipCode('')
    }
    return <Dialog open={open} onClose={() => onClose()}>
        <DialogTitle style={{padding: 10}}>
            {textsAddress.zipCode}
        </DialogTitle>
        <DialogContent style={{padding: 10}}>
            <DialogContentText>
                {textsAddress.enterTheZipCode}
            </DialogContentText>
            <Box p={1}/>
            <TextField
                value={zipCode}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                color={'secondary'}
                type={'tel'}
                label={textsAddress.zipCode}
                autoFocus={true}
                placeholder={'00000-00'}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                onChange={handleChange}
            />
            <div className={'div-dialog-confirmation'}>
                {(!zipCodeRequired) && <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'confirm'}
                    onClick={() => notZipCode()}
                    title={textsAddress.iDontKnowTheZipCode}
                />}
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => confirm()}
                />
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogLoading = ({open, message}) => {
    return <Dialog open={open}>
        <DialogContent>
            <div className={'div-dialog-loading'}>
                <Lottie
                    animationData={loading}
                    className={'lottie-loading'}/>
                <label className={'label-dialog-loading'}>
                    {message}
                </label>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogChange = ({open, onMessage, onClose, onClick}) => {
    const [change, setChange] = useState(0)
    const calculatesValues = () => {
        const discountCoupon = getSession('discountCoupon', {value: 0})
        const discount = discountCoupon.value
        const deliveryFee = getLocal('deliveryFee', 0)
        const totalItems = getSession('totalItems', 0)
        return ((deliveryFee + totalItems) - discount)
    }
    const total = calculatesValues()

    const handleChange = (e) => {
        const value = e.target.value.replace(',', '.')
        setChange(parseFloat(value))
    }

    const confirm = () => {
        if (isEmpty(change)) return onMessage(textsPaymentMethods.invalidValue)
        if (change < total) return onMessage(textsPaymentMethods.changeLessThanTotal)
        if (change > 25 * total) return onMessage(textsPaymentMethods.changeMoreThanTotal)
        onClick(change)
    }

    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsPaymentMethods.change}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsPaymentMethods.howMuchDoIExchange}
            </DialogContentText>
            <DialogContentText className={'dialog-content-text-total'}>
                {`${textsShoppingCart.total} ${total.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                })}`}
            </DialogContentText>
            <Box p={1} sx={{minWidth: 210}}/>
            <div>
                <TextField
                    autoFocus={true}
                    fullWidth={true}
                    InputLabelProps={{shrink: true}}
                    color={'secondary'}
                    type={'number'}
                    label={textsPaymentMethods.change}
                    placeholder={textsPaymentMethods.change}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') confirm()
                    }}
                    onChange={handleChange}
                />
            </div>
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={textsGeneral.cancel}
                    onClick={() => onClose()}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => confirm()}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogProfile = ({open, onMessage, viewLogout, onClose, onClick}) => {
    const totem = getLocal('totem', false)
    const {name, phone, cpf, loggedIn} = getLocal('profile', {
        name: isDebug('5173') ? 'Felipe' : '',
        phone: isDebug('5173') ? '51994007054' : '',
        cpf: isDebug('5173') ? '85292702072' : '',
        loggedIn: false
    })
    const [profile, setProfile] = useState({
        name: name,
        phone: !!phone ? maskInternationalPhone(phone) : '',
        cpf: maskCPF_CNPJ(cpf),
        loggedIn: loggedIn
    })
    const handleChange = (e) => {
        if (e.target.name === 'name') {
            setProfile({...profile, name: capitalizeFirstLetter(e.target.value)})
        } else if (e.target.name === 'phone') {
            setProfile({...profile, phone: (!!e.target.value) ? maskInternationalPhone(e.target.value) : ''})
        } else {
            setProfile({...profile, cpf: maskCPF_CNPJ(e.target.value.substring(0, 18))})
        }
    }
    const handleClickLogout = () => {
        clearLocal()
        clearSession()
        window.location.reload()
    }
    const confirm = () => {
        if (isEmpty(profile.name)) return onMessage(textsGeneral.invalidName)
        if (!totem && (isEmpty(profile.phone) || !isPhone(profile.phone))) return onMessage(textsGeneral.invalidPhone)
        if (!totem) {
            if (profile.cpf.length > 14) {
                if (!isCNPJ(profile.cpf)) return onMessage(textsGeneral.invalidCnpj)
            } else {
                if (!isCPF(profile.cpf)) return onMessage(textsGeneral.invalidCpf)
            }
        }
        profile.phone = cleanTextToNumbers(profile.phone)
        profile.cpf = cleanTextToNumbers(profile.cpf)
        onClick(profile, totem)
    }
    return <Dialog open={open}>
        <DialogTitle>
            {textsGeneral.orderInformation}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.warningInformation}
            </DialogContentText>
            <Box p={1}/>
            <TextField
                value={profile.name}
                name={'name'}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                color={'secondary'}
                autoFocus={true}
                required={true}
                autoComplete={totem ? 'off' : 'on'}
                label={textsGeneral.name}
                placeholder={textsGeneral.name}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                onChange={handleChange}
            />
            {(!totem) && <>
                <Box p={1}/>
                <TextField
                    value={profile.phone}
                    name={'phone'}
                    fullWidth={true}
                    InputLabelProps={{shrink: true}}
                    color={'secondary'}
                    type={'tel'}
                    required={!totem}
                    label={textsGeneral.phone}
                    placeholder={textsGeneral.phone}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') confirm()
                    }}
                    onChange={handleChange}
                />
                <Box p={1}/>
                <TextField
                    value={profile.cpf}
                    name={'cpf'}
                    fullWidth={true}
                    InputLabelProps={{shrink: true}}
                    color={'secondary'}
                    type={'tel'}
                    required={!totem}
                    label={textsGeneral.cpf}
                    placeholder={textsGeneral.cpf}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') confirm()
                    }}
                    onChange={handleChange}
                />
            </>}
            <div className={'div-dialog-perfil'}>
                <div>
                    {viewLogout && <ButtonMui
                        color={'secondary'}
                        style={{marginTop: 20}}
                        endIcon={<LogoutRounded color={'secondary'}/>}
                        onClick={handleClickLogout}>
                        Logout
                    </ButtonMui>}
                </div>
                <div className={'div-dialog-confirmation'}>
                    <Button
                        className={'button-dialog'}
                        variant={'outline'}
                        value={'confirm'}
                        title={textsGeneral.toClose}
                        onClick={() => onClose()}
                    />
                    <Button
                        className={'button-dialog'}
                        value={'confirm'}
                        title={textsGeneral.confirm}
                        onClick={() => confirm()}
                    />
                </div>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogDiscountCoupon = ({open, onClose, onClick, onRemove}) => {
    const {discountCoupon} = getSession('discountCoupon', {discountCoupon: ''})
    const [coupon, setCoupon] = useState(discountCoupon)
    const handleChange = (event) => setCoupon(event.target.value.toUpperCase())
    const confirm = () => {
        const discountCoupon = getSession('discountCoupon', {})
        if (!isEmpty(discountCoupon)) onRemove(false)
        if (isEmpty(coupon)) return onRemove(true)
        onClick(coupon)
    }
    return <Dialog open={open}>
        <DialogTitle>
            {textsShoppingCart.discountCoupon}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsShoppingCart.validateCoupon}
            </DialogContentText>
            <Box p={1}/>
            <TextField
                value={coupon}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {coupon ? <Cancel onClick={() => onRemove(true)}/> : <div style={{width: 24}}/>}
                        </InputAdornment>
                    ),
                }}
                color={'secondary'}
                placeholder={textsShoppingCart.discountCoupon}
                label={textsShoppingCart.discountCoupon}
                onChange={handleChange}
            />
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    title={textsGeneral.toClose}
                    onClick={() => onClose()}
                />
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => confirm()}
                />
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogSendingSuccess = ({open, onClick}) => {
    const totem = getLocal('totem', false)
    useEffect(() => {
        setTimeout(() => onClick(), 5000)
    }, [])
    return <Dialog open={open}>
        <DialogContent>
            <div className={'div-dialog-sending-success'}>
                <Lottie
                    animationData={checked}
                    className={'lottie-sending-success'}/>
                <label className={'label-dialog-loading'}>
                    {textsShoppingCart.orderSentSuccessfully}
                </label>
            </div>
            {(!totem) && <Button
                className={'button-dialog'}
                value={'cancel'}
                title={textsShoppingCart.trackOrder}
                onClick={() => onClick()}
            />}
        </DialogContent>
    </Dialog>
}

export const DialogErrorOrCancellation = ({open, onClick, message}) => {
    return <Dialog open={open}>
        <DialogContent>
            <div className={'div-dialog-sending-success'}>
                <Lottie
                    animationData={error}
                    className={'lottie-sending-success'}/>
                <label className={'label-dialog-loading'}>
                    {message}
                </label>
            </div>
            <Button
                className={'button-dialog'}
                value={'cancel'}
                title={textsGeneral.toClose}
                onClick={() => onClick()}
            />
        </DialogContent>
    </Dialog>
}

export const DialogCashback = ({open, cashback, onMessage, onRemove, onClose, onClick}) => {
    const deliveryFee = getLocal('deliveryFee', 0)
    const totalItems = getSession('totalItems', 0)
    const total = (totalItems + deliveryFee)
    const rescue = (cashback.rescue || cashback.balance || 0)
    const valueRescue = (rescue > total) ? total : rescue
    const [amount, setAmount] = useState(valueRescue)
    const [finaleAmount, setFinalAmount] = useState(cashback.balance - cashback.rescue)

    const handleChange = event => {
        let value = parseFloat(event.target.value) || 0
        value = parseFloat(value.toFixed(2))
        if (value > total) {
            setFinalAmount(total)
            setAmount(total)
            onMessage(textsShoppingCart.maximumRescue)
        } else if (value > cashback.balance) {
            setFinalAmount(0)
            setAmount(cashback.balance)
        } else {
            setFinalAmount((cashback.balance - value))
            setAmount(value || '')
        }
    }

    const confirm = () => {
        if (amount > total) return onMessage(textsShoppingCart.maximumRescue)
        onClick(parseFloat(amount || 0))
    }

    return <Dialog open={open}>
        <DialogTitle>
            {textsShoppingCart.cashback}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsShoppingCart.wantToRescue}
            </DialogContentText>
            <Box p={1}/>
            <div className={'div-balances-cashback'}>
                <label className={'opening-balance'}>
                    {`${textsShoppingCart.initialBalance}: ${cashback.balance.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}`}
                </label>
                <Box p={1}/>
                <label className={'ending-balance'}>
                    {`${textsShoppingCart.finalBalance}: ${(finaleAmount).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}`}
                </label>
            </div>
            <Box p={1}/>
            <TextField
                autoFocus={true}
                value={amount}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                color={'secondary'}
                type={'number'}
                label={textsShoppingCart.valueToBeRedeemed}
                placeholder={textsShoppingCart.valueToBeRedeemed}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {cashback.balance ?
                                <Cancel className={'icon-remove-cashback'} onClick={() => onRemove(0)}/> :
                                <div style={{width: 24}}/>}
                        </InputAdornment>
                    ),
                }}
                onChange={handleChange}
            />
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={textsGeneral.cancel}
                    onClick={onClose}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => confirm()}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogScheduledOrderType = ({open, onClick, onClose}) => {
    const scheduledOrderType = getSession('scheduledOrderType', 'immediate')
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsShoppingCart.scheduleOrder}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.chooseAnOption}
            </DialogContentText>
            <Box p={1}/>
            <div
                className={'div-option-scheduled'}
                id={(scheduledOrderType === 'immediate') ? 'option-selected-scheduled' : ''}
                onClick={() => onClick('immediate')}>
                <div>
                    <label className={'label-option'}>
                        {textsShoppingCart.immediateRequest}
                    </label>
                </div>
                <Box p={2}/>
                <CheckCircleIcon
                    className={'icon-select-option'}
                    id={(scheduledOrderType === 'immediate') ? 'icon-selected-scheduled' : ''}/>
            </div>
            <div
                className={'div-option-scheduled'}
                id={(scheduledOrderType === 'scheduled') ? 'option-selected-scheduled' : ''}
                onClick={() => onClick('scheduled')}>
                <div>
                    <label className={'label-option'}>
                        {textsShoppingCart.scheduledOrder}
                    </label>
                </div>
                <Box p={2}/>
                <CheckCircleIcon
                    className={'icon-select-option'}
                    id={(scheduledOrderType === 'scheduled') ? 'icon-selected-scheduled' : ''}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogDate = ({open, onMessage, onClose, onClick}) => {
    const modules = getLocal('modules')
    const scheduledday = getLocal('scheduledday', false)
    const nextDay = ((modules !== 3 && modules !== 4) && (scheduledday))
    const currentDay = nextDay ? moment().add(1, 'day').format('yyyy-MM-DD') : moment().format('yyyy-MM-DD')
    const [date, setDate] = useState(currentDay)
    const handleChange = event => setDate(event.target.value)
    const confirm = () => {
        if (!date) return onMessage(textsGeneral.invalidDate)
        onClick(date)
    }
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsShoppingCart.deliveryData}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsShoppingCart.chooseDeliveryDate}
            </DialogContentText>
            <Box p={1} sx={{minWidth: 210}}/>
            <TextField
                value={date}
                fullWidth={true}
                InputLabelProps={{shrink: true}}
                inputProps={{min: currentDay}}
                // autoFocus={true}
                color={'secondary'}
                type={'date'}
                label={textsShoppingCart.date}
                placeholder={textsShoppingCart.date}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') confirm()
                }}
                onChange={handleChange}
            />
            <div className={'div-dialog-confirmation'}>
                <Button
                    className={'button-dialog'}
                    variant={'outline'}
                    value={'cancel'}
                    title={textsGeneral.cancel}
                    onClick={() => onClose()}/>
                <Button
                    className={'button-dialog'}
                    value={'confirm'}
                    title={textsGeneral.confirm}
                    onClick={() => confirm()}/>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogFlavor = ({open, flavorItems, onClick, onClose}) => {
    return <Dialog
        open={open}
        onClose={onClose}>
        <DialogTitle>
            {textsShoppingCart.flavorAssistant}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsShoppingCart.textAssistant}
            </DialogContentText>
            <ListFlavor listFlavor={flavorItems} onClick={onClick}/>
        </DialogContent>
    </Dialog>
}

export const DialogQuantity = ({open, onClick, onClose, product}) => {
    const {productQuantity, setProductQuantity, setAddItem, isAddItem, setSnackbar} = useContext(ItemBagContext)
    const [settings, setSettings] = useState({maximumQuantity: 100})
    const handleClickAdd = (amount = 1) => {
        if ((productQuantity + amount) > settings.maximumQuantity) return setSnackbar({
            open: true,
            message: `${textsItemBag.maximumQuantity}"${settings.maximumQuantity}"`
        })
        setAddItem(!isAddItem)
        setProductQuantity((productQuantity + amount))
    }
    const handleClickRemove = () => {
        if ((settings.minimumQuantity !== 1) && (productQuantity <= settings.minimumQuantity)) return setSnackbar({
            open: true,
            message: `${textsItemBag.minimumQuantity}"${settings.minimumQuantity}"`
        })
        if (productQuantity !== 1) {
            setAddItem(!isAddItem)
            setProductQuantity((productQuantity - 1))
        }
    }

    useEffect(() => checkQuantities(), [])

    const checkQuantities = () => {
        const maximumQuantityLocal = getLocal(`maximumQuantity=${product.sku}`)
        const maximumQuantity = !!maximumQuantityLocal ? maximumQuantityLocal : product.qtdeMaxAuto
        setSettings({maximumQuantity: maximumQuantity})
    }

    return <Dialog
        open={open}
        onClose={onClose}>
        <DialogTitle>
            {textsItemBag.quantity}
        </DialogTitle>
        <DialogContent>
            <div className={'div-amount-product'}>
                <div className={'left'}>
                    <IconButton onClick={handleClickRemove}>
                        <RemoveIcon className={'icon-information'}/>
                    </IconButton>
                </div>
                <div className={'center'} onClick={onClick}>
                    <label className={'label-amount'}>
                        {productQuantity}
                    </label>
                </div>
                <div className={'right'}>
                    <IconButton onClick={() => handleClickAdd(1)}>
                        <AddIcon className={'icon-information'}/>
                    </IconButton>
                </div>
            </div>
            <Box p={1}/>
            <div className={'div-quantitys'}>
                <div className={'row'}>
                    {(settings.maximumQuantity > 5) &&
                        <Button onClick={() => handleClickAdd(5)} className={'button'} title={'+ 5'}/>}
                    {(settings.maximumQuantity > 10) &&
                        <Button onClick={() => handleClickAdd(10)} className={'button'} title={'+ 10'}/>}
                </div>
                <div className={'row'}>
                    {(settings.maximumQuantity > 25) &&
                        <Button onClick={() => handleClickAdd(25)} className={'button'} title={'+ 25'}/>}
                    {(settings.maximumQuantity > 50) &&
                        <Button onClick={() => handleClickAdd(50)} className={'button'} title={'+ 50'}/>}
                </div>
            </div>
        </DialogContent>
    </Dialog>
}

export const DialogTypeLogin = ({open, onClick, onClose}) => {
    return <Dialog
        open={open}
        onClose={onClose}>
        <DialogTitle>
            {textsGeneral.login}
        </DialogTitle>
        <DialogContent>
            <Button
                className={'button-type-login'}
                title={textsShoppingCart.buyWithoutRegistration}
                onClick={() => onClick('without')}
            />
            <Button
                variant={'outline'}
                className={'button-type-login'}
                title={textsShoppingCart.registered}
                onClick={() => onClick('with')}
            />
        </DialogContent>
    </Dialog>
}

export const DialogForgotPassword = ({open, onClick, onClose}) => {
    const [email, setEmail] = useState('')
    const handleInput = (e) => setEmail(e.target.value)
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsGeneral.recoverPassword}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.warningPasswordRecovery}
            </DialogContentText>
            <TextField
                color={'secondary'}
                margin={'normal'}
                autoFocus={true}
                fullWidth={true}
                type={'email'}
                label={textsGeneral.email}
                placeholder={textsGeneral.email}
                onChange={handleInput}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') onClick(email)
                }}
            />
            <Button
                className={'button-type-login'}
                title={textsGeneral.confirm}
                onClick={() => onClick(email)}
            />
        </DialogContent>
    </Dialog>
}

export const DialogCodeRecoveryPassword = ({open, onClick, onClose}) => {
    const [code, setCode] = useState('')
    const handleInput = (e) => setCode(e.target.value)
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsGeneral.codeRecovery}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.warningCodeRecovery}
            </DialogContentText>
            <TextField
                color={'secondary'}
                margin={'normal'}
                autoFocus={true}
                type={'number'}
                fullWidth={true}
                label={textsGeneral.code}
                placeholder={textsGeneral.code}
                onChange={handleInput}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') onClick(code)
                }}
            />
            <Button
                className={'button-type-login'}
                title={textsGeneral.confirm}
                onClick={() => onClick(code)}
            />
        </DialogContent>
    </Dialog>
}

export const DialogResetPassword = ({open, client, onClick, onClose}) => {
    const [password, setPassword] = useState('')
    const handleInput = (e) => setPassword(e.target.value)
    return <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            {textsGeneral.newPassword}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {textsGeneral.enterNewPassword}
            </DialogContentText>
            <TextField
                color={'secondary'}
                margin={'normal'}
                autoFocus={true}
                fullWidth={true}
                label={textsGeneral.password}
                placeholder={textsGeneral.password}
                onChange={handleInput}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') onClick(password, client)
                }}
            />
            <Button
                className={'button-type-login'}
                title={textsGeneral.confirm}
                onClick={() => onClick(password, client)}
            />
        </DialogContent>
    </Dialog>
}

/* fullScreen */

export const DialogQuestions = ({open, onClose, onConfirm, onMessage}) => {
    const [questions] = useState(getLocal('questions', []))
    const {answersQuestions, setAnswersQuestions} = useContext(ShoppingCartContext)
    const [amounts, setAmounts] = useState({})

    const confirm = () => {
        const mandatorys = questions.filter((q) => ((q.type === 0) || (q.type === 1) || ((q.type === 2) && (q.answer[0] >= 1))))
        for (const m of mandatorys) {
            if (m.type === 2) {
                const i = answersQuestions.filter((a) => ((a.code === m.code) && (a.response >= m.answer[0])))
                if (!i.length) return onMessage(`"${m.question}" ${textsItemBag.minimumQuantity} ${m.answer[0]}`)
            } else {
                const i = answersQuestions.filter((a) => ((a.code === m.code)))
                if (!i.length) return onMessage(`${textsItemBag.mandatoryStep} "${m.question}"`)
            }
        }
        setSession('answersQuestions', answersQuestions)
        onConfirm()
    }

    const handleChangeOption = (reponse, {code, type, question, internal}) => {
        const index = answersQuestions.findIndex((a) => (a.code === code))
        if (index === -1) {
            answersQuestions.push({code: code, response: reponse, type: type, question: question, internal: internal})
        } else {
            answersQuestions[index] = {
                code: code,
                response: reponse,
                type: type,
                question: question,
                internal: internal
            }
        }
        setAnswersQuestions([...answersQuestions])
    }

    const handleChangeCheck = (event, {code, type, question, internal}) => {
        const index = answersQuestions.findIndex((a) => (a.code === code))
        if ((index === -1) || (event.target.checked)) {
            answersQuestions.push({
                code: code,
                response: event.target.value,
                type: type,
                question: question,
                internal: internal
            })
        } else {
            const index = answersQuestions.findIndex((a) => (a.response === event.target.value))
            answersQuestions.splice(index, 1)
        }
        setAnswersQuestions([...answersQuestions])
    }

    const handleChangeButton = (event, {code, answer, type, question, internal}, isAdd) => {
        const index = answersQuestions.findIndex((a) => (a.code === code))
        if (index === -1 && isAdd) {
            answersQuestions.push({code: code, response: 1, type: type, question: question, internal: internal})
            amounts[code] = 1
            setAmounts({...amounts})
        } else {
            if (isAdd) {
                let amount = amounts[code]
                if (++amount > answer[1]) return onMessage(textsItemBag.limitMaximum)
                amounts[code] = amount
                answersQuestions[index] = {
                    code: code,
                    response: amount,
                    type: type,
                    question: question,
                    internal: internal
                }
                setAmounts({...amounts})
            } else {
                let amount = isEmpty(amounts[code]) ? 0 : amounts[code]
                if (--amount < answer[0]) return onMessage(textsItemBag.limitMinimum)
                amounts[code] = amount
                answersQuestions[index] = {
                    code: code,
                    response: amount,
                    type: type,
                    question: question,
                    internal: internal
                }
                setAmounts({...amounts})
            }
        }
        setAnswersQuestions([...answersQuestions])
    }

    const isRadioButtonChecked = ({code}, response) => {
        const filter = answersQuestions.filter((a) => (a.code === code && a.response === response))
        return (!!filter.length)
    }

    const isCheckButtonChecked = ({code}, response) => {
        const filter = answersQuestions.filter((a) => ((a.code === code) && (a.response === response)))
        return (!!filter.length)
    }

    const checkAnswersQuestions = () => {
        const answersQuestions = getSession('answersQuestions', [])
        setAnswersQuestions([...answersQuestions])
        answersQuestions.forEach((a) => {
            if (a.type === 2) {
                amounts[a.code] = a.response
                setAmounts({...amounts})
            }
        })
    }

    useEffect(() => checkAnswersQuestions(), [open])

    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}}}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsShoppingCart.questions}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <motion.div
                initial={{x: 400}}
                animate={{x: 0}}
                exit={{x: 400, opacity: 0}}
                transition={{duration: 0.3}}>
                <div className={'div-questions'}>
                    <div className={'div-container-questions'}>
                        {questions.map((question, i) => {
                            if (question.type === 0) {
                                /*Radio Button*/
                                return <div className={'div-item-question'} key={i}>
                                    <label className={'label-question'}>
                                        {question.question}
                                    </label>
                                    <RadioGroup className={'radio-group'}>
                                        <FormControlLabel
                                            onChange={() => handleChangeOption('Sim', question)}
                                            style={{color: textBodyColor}}
                                            control={<Radio style={{color: textBodyColor}}/>}
                                            checked={isRadioButtonChecked(question, 'Sim')}
                                            label={textsGeneral.yes}
                                            value={true}/>
                                        <FormControlLabel
                                            onChange={() => handleChangeOption('Não', question)}
                                            style={{color: textBodyColor}}
                                            control={<Radio style={{color: textBodyColor}}/>}
                                            checked={isRadioButtonChecked(question, 'Não')}
                                            label={textsGeneral.no}
                                            value={false}/>
                                    </RadioGroup>
                                </div>
                            } else if (question.type === 1) {
                                /*List Radio Button*/
                                return <div className={'div-item-question'} key={i}>
                                    <label className={'label-question'}>
                                        {question.question}
                                    </label>
                                    <div className={'div-checks'}>
                                        {question.answer.map((answer, i) =>
                                            <FormControlLabel
                                                key={i}
                                                onChange={(event) => handleChangeOption(answer, question)}
                                                style={{color: textBodyColor}}
                                                control={<Radio style={{color: textBodyColor}}/>}
                                                checked={isRadioButtonChecked(question, answer)}
                                                label={answer}
                                                value={answer}/>
                                        )}
                                    </div>
                                </div>
                            } else if (question.type === 2) {
                                /*Add Button*/
                                return <div className={'div-item-question'} key={i}>
                                    <label className={'label-question'}>
                                        {question.question}
                                    </label>
                                    <div className={'div-amount-item'}>
                                        <div className={'amount'}>
                                            <div className={'left'}>
                                                <IconButton
                                                    onClick={(event) => handleChangeButton(event, question, false)}>
                                                    <RemoveIcon className={'icon-information'}/>
                                                </IconButton>
                                            </div>
                                            <div className={'center'}>
                                                <label className={'label-amount'}>
                                                    {isEmpty(amounts[question.code]) ? 0 : amounts[question.code]}
                                                </label>
                                            </div>
                                            <div className={'right'}>
                                                <IconButton
                                                    onClick={(event) => handleChangeButton(event, question, true)}>
                                                    <AddIcon className={'icon-information'}/>
                                                </IconButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            } else if (question.type === 3) {
                                /*Check Button*/
                                return <div className={'div-item-question'} key={i}>
                                    <label className={'label-question'}>
                                        {question.question}
                                    </label>
                                    <div className={'div-checks'}>
                                        {question.answer.map((answer, i) =>
                                            <FormControlLabel
                                                key={i}
                                                onChange={(event) => handleChangeCheck(event, question)}
                                                style={{color: textBodyColor}}
                                                control={<Checkbox style={{color: textBodyColor}}/>}
                                                checked={isCheckButtonChecked(question, answer)}
                                                label={answer}
                                                value={answer}/>
                                        )}
                                    </div>
                                </div>
                            }
                        })}
                    </div>
                </div>
            </motion.div>
        </DialogContent>
        <div className={'div-buttons-questions'}>
            <Button
                style={{marginTop: 10, marginBottom: 10}}
                className={'button-dialog'}
                value={'confirm'}
                title={textsGeneral.confirm}
                onClick={() => confirm()}
            />
        </div>
    </Dialog>
}

export const DialogAddressWithoutZipCode = ({open, data, onClose, onClick}) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })
    const serviceArea = getLocal('serviceArea')
    const isCityServiceArea = (!!data) ? checkCityServiceArea(data.city) : false
    const indexCity = isCityServiceArea ? serviceArea.findIndex((sa) => sa.name.toLowerCase() === data.city.toLowerCase()) : 0
    const [city, setCity] = useState((indexCity !== -1) ? indexCity : 0)
    const [hasNoComplement, setHasNoComplement] = useState(false)
    const [dataAddress, setDataAddress] = useState({
        id: '',
        street: '',
        neighborhood: '',
        city: isCityServiceArea ? data.city : '',
        uf: isCityServiceArea ? data.uf : '',
        number: '',
        addressComplement: ''
    })
    const handleSelect = (e) => {
        setCity(e.target.value)
        setDataAddress({
            ...dataAddress, city: serviceArea[e.target.value].name, uf: serviceArea[e.target.value].UF
        })
    }
    const handleCloseSnackbar = () => setSnackbar({...snackbar, open: false})
    const handleChange = (e) => setDataAddress({...dataAddress, [e.target.name]: e.target.value})
    const handleChangeCheck = event => setHasNoComplement(event.target.checked)
    const confirm = () => {
        if (isEmpty(dataAddress.city)) return setSnackbar({
            open: true,
            message: textsAddress.invalidCity
        })
        if (isEmpty(dataAddress.neighborhood)) return setSnackbar({
            open: true,
            message: textsAddress.invalidNeighborhood
        })
        if (isEmpty(dataAddress.number)) return setSnackbar({
            open: true,
            message: textsAddress.invalidNumber
        })
        if (isEmpty(dataAddress.street)) return setSnackbar({
            open: true,
            message: textsAddress.invalidStreet
        })
        if (isEmpty(dataAddress.addressComplement) && !hasNoComplement) return setSnackbar({
            open: true,
            message: textsAddress.confirmationNotComplement
        })
        onClick(dataAddress)
    }

    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}}}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsAddress.registerAddress}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <div className={'div-address-registration'}>
                <div className={'div-container-address'}>
                    <DialogContentText>
                        {textsAddress.registerNewAddress}
                    </DialogContentText>
                    <Box p={1}/>
                    <div className={'div-new-address'}>
                        {(!!serviceArea.length) && <FormControl fullWidth={true} color={'secondary'} focused={true}>
                            <InputLabel>
                                {textsAddress.city}
                            </InputLabel>
                            <Select
                                displayEmpty
                                defaultValue={isCityServiceArea ? indexCity : ''}
                                name={'city'}
                                autoFocus={true}
                                label={textsAddress.city}
                                onChange={handleSelect}>
                                <MenuItem value="" disabled={true}>
                                    {textsAddress.selectCity}
                                </MenuItem>
                                {serviceArea.map((s, i) => <MenuItem key={i} value={i}>
                                    {s.name}
                                </MenuItem>)}
                            </Select>
                        </FormControl>
                        }
                    </div>
                    <Box p={1}/>
                    <div className={'div-new-address'}>
                        {(!!serviceArea.length) && <FormControl fullWidth={true} color={'secondary'} focused={true}>
                            <InputLabel>
                                {textsAddress.neighborhood}
                            </InputLabel>
                            <Select
                                displayEmpty
                                defaultValue={''}
                                name={'neighborhood'}
                                label={textsAddress.neighborhood}
                                onChange={handleChange}>
                                <MenuItem value="" disabled={true}>
                                    {textsAddress.selectNeighborhood}
                                </MenuItem>
                                {serviceArea[city].districts.map((n, i) => <MenuItem key={i} value={n.name}>
                                        {n.name}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>}

                    </div>
                    <Box p={1}/>
                    <div className={'div-new-address'}>
                        <TextField
                            name={'street'}
                            fullWidth={true}
                            InputLabelProps={{shrink: true}}
                            color={'secondary'}
                            label={textsAddress.street}
                            placeholder={textsAddress.street}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') confirm()
                            }}
                            onChange={handleChange}
                        />
                        <Box p={1}/>
                        <TextField
                            name={'number'}
                            InputLabelProps={{shrink: true}}
                            color={'secondary'}
                            type={'number'}
                            label={'N°'}
                            placeholder={'N°'}
                            onChange={handleChange}
                        />
                    </div>
                    <Box p={1}/>
                    <div className={'div-new-address'}>
                        <TextField
                            name={'addressComplement'}
                            fullWidth={true}
                            InputLabelProps={{shrink: true}}
                            color={'secondary'}
                            type={'tel'}
                            label={textsAddress.addressComplement}
                            placeholder={textsAddress.addressComplement}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') confirm()
                            }}
                            onChange={handleChange}
                        />
                    </div>
                    <>
                        <Box p={1}/>
                        <div className={'div-new-address'}>
                            <FormControlLabel
                                sx={{'& .MuiTypography-root': {fontFamily: 'Nunito', color: textBodyColor}}}
                                checked={hasNoComplement}
                                onChange={handleChangeCheck}
                                control={<Checkbox style={{color: titleColor}}/>}
                                label={textsAddress.hasNoComplement}/>
                        </div>
                    </>
                </div>
            </div>
        </DialogContent>
        <div className={'div-button-address-registration'}>
            <Button
                style={{marginTop: 10, marginBottom: 10}}
                className={'button-dialog'}
                value={'confirm'}
                title={textsGeneral.confirm}
                onClick={() => confirm()}
            />
        </div>
        <Snackbar
            open={snackbar.open}
            autoHideDuration={1600}
            onClose={handleCloseSnackbar}
            message={snackbar.message}/>
    </Dialog>
}

export const DialogAddressRegistration = ({open, data, isEditing, withoutZipCode, onClose, onClick}) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })
    const [hasNoComplement, setHasNoComplement] = useState(false)
    const [dataAddress, setDataAddress] = useState({
        id: checkUndefined(data.id, ''),
        street: data.street,
        neighborhood: data.neighborhood,
        city: data.city,
        zipCode: data.zipCode,
        uf: data.uf,
        number: checkUndefined(data.number, ''),
        latitude: data.latitude,
        longitude: data.longitude,
        radius: data.radius,
        addressComplement: checkUndefined(data.addressComplement, '')
    })
    const [error, setError] = useState({
        number: false,
        addressComplement: false
    })
    const handleChange = (e) => {
        if (e.target.name === 'number') setError({...e, number: false})
        if (e.target.name === 'addressComplement') setError({...e, number: false})
        setDataAddress({
            ...dataAddress,
            [e.target.name]: (e.target.name === 'zipCode') ? cleanTextToNumbers(e.target.value.substring(0, 8)) : e.target.value
        })
    }
    const handleCloseSnackbar = () => setSnackbar({...snackbar, open: false})
    const handleChangeCheck = event => setHasNoComplement(event.target.checked)
    const confirm = () => {
        if (isEmpty(dataAddress.street)) return setSnackbar({
            open: true,
            message: textsAddress.invalidStreet
        })
        if (isEmpty(dataAddress.neighborhood)) return setSnackbar({
            open: true,
            message: textsAddress.invalidNeighborhood
        })
        if ((!withoutZipCode) && (isEmpty(dataAddress.zipCode) || dataAddress.zipCode.length < 8)) return setSnackbar({
            open: true,
            message: textsAddress.invalidZipCode
        })
        if (isEmpty(dataAddress.city)) return setSnackbar({
            open: true,
            message: textsAddress.invalidCity
        })
        if (isEmpty(dataAddress.number)) {
            setError({...error, number: true})
            return setSnackbar({
                open: true,
                message: textsAddress.invalidNumber
            })
        }
        if (isEmpty(dataAddress.addressComplement) && !hasNoComplement) {
            setError({...error, addressComplement: true})
            return setSnackbar({
                open: true,
                message: textsAddress.confirmationNotComplement
            })
        }
        onClick(dataAddress)
    }
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsAddress.registerAddress}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <div className={'div-address-registration'}>
                <div className={'div-container-address'}>
                    <DialogContentText>
                        {textsAddress.registerNewAddress}
                    </DialogContentText>
                    <Box p={1}/>
                    <div className={'div-new-address'}>
                        <TextField
                            name={'street'}
                            value={dataAddress.street}
                            disabled={true}
                            fullWidth={true}

                            InputLabelProps={{shrink: true}}
                            color={'secondary'}
                            label={textsAddress.street}
                            placeholder={textsAddress.street}
                            onChange={handleChange}
                        />
                    </div>
                    <Box p={1}/>
                    <div className={'div-new-address'}>
                        <TextField
                            name={'neighborhood'}
                            value={dataAddress.neighborhood}
                            disabled={true}
                            fullWidth={true}
                            InputLabelProps={{shrink: true}}
                            color={'secondary'}
                            label={textsAddress.neighborhood}
                            placeholder={textsAddress.neighborhood}
                            onChange={handleChange}
                        />
                        {(!withoutZipCode) && <>
                            <Box p={1}/>
                            <TextField
                                name={'zipCode'}
                                value={dataAddress.zipCode}
                                disabled={true}
                                fullWidth={true}
                                InputLabelProps={{shrink: true}}
                                color={'secondary'}
                                type={'tel'}
                                label={textsAddress.zipCode}
                                placeholder={textsAddress.zipCode}
                                onChange={handleChange}
                            />
                        </>}
                    </div>
                    <Box p={1}/>
                    <div className={'div-new-address'}>
                        <TextField
                            name={'city'}
                            value={dataAddress.city}
                            disabled={true}
                            fullWidth={true}
                            InputLabelProps={{shrink: true}}
                            color={'secondary'}
                            label={textsAddress.city}
                            placeholder={dataAddress.city}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') confirm()
                            }}
                            onChange={handleChange}
                        />
                        <Box p={1}/>
                        <TextField
                            error={error.number}
                            name={'number'}
                            value={dataAddress.number}
                            autoFocus={isEditing}
                            InputLabelProps={{shrink: true}}
                            color={'secondary'}
                            type={'number'}
                            label={'N°'}
                            placeholder={'N°'}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') confirm()
                            }}
                            onChange={handleChange}
                        />
                    </div>
                    <Box p={1}/>
                    <div className={'div-new-address'}>
                        <TextField
                            error={error.addressComplement}
                            name={'addressComplement'}
                            value={dataAddress.addressComplement}
                            fullWidth={true}
                            InputLabelProps={{shrink: true}}
                            color={'secondary'}
                            label={textsAddress.addressComplement}
                            placeholder={textsAddress.addressComplement}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') confirm()
                            }}
                            onChange={handleChange}
                        />
                    </div>
                    <>
                        <Box p={1}/>
                        <div className={'div-new-address'}>
                            <FormControlLabel
                                sx={{'& .MuiTypography-root': {fontFamily: 'Nunito', color: textBodyColor}}}
                                checked={hasNoComplement}
                                onChange={handleChangeCheck}
                                control={<Checkbox style={{color: textBodyColor}}/>}
                                label={textsAddress.hasNoComplement}/>
                        </div>
                    </>
                </div>
            </div>
        </DialogContent>
        <div className={'div-button-address-registration'}>
            <Button
                style={{marginTop: 10, marginBottom: 10}}
                className={'button-dialog'}
                value={'confirm'}
                title={textsGeneral.confirm}
                onClick={() => confirm()}
            />
        </div>
        <Snackbar
            open={snackbar.open}
            autoHideDuration={1600}
            onClose={handleCloseSnackbar}
            message={snackbar.message}/>
    </Dialog>
}

export const DialogOrderConfirmation = ({open, cashback, onEdit, onClick, onClose}) => {
    const {restartButton} = useContext(ShoppingCartContext)
    const [textoBotao, setTextoBotao] = useState('')
    const [enable, setEnable] = useState(false)
    const [time, setTime] = useState('')

    const handlePressKeyboard = event => {
        if (event.key === 'Escape') {
            onClose()
        } else if (event.key === 'F8') {
            onClick()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handlePressKeyboard, false)
        return () => document.removeEventListener('keydown', handlePressKeyboard, false)
    }, [])

    useEffect(() => {
        setTextoBotao('Aguardando revisão do pedido')
        setEnable(false)
        setTime('')

        const tempoTotal = 6000
        const intervalo = 1500

        const timeouts = []

        timeouts.push(setTimeout(() => {
            setTextoBotao(textsGeneral.reviewAddressData)
            setTime('3')
        }, intervalo))

        timeouts.push(setTimeout(() => {
            setTextoBotao(textsGeneral.reviewTheValues)
            setTime('2')
        }, intervalo * 2))

        timeouts.push(setTimeout(() => {
            setTextoBotao(textsGeneral.reviewTheOrderInformation)
            setTime('1')
        }, intervalo * 3))

        timeouts.push(setTimeout(() => {
            setTextoBotao(`${textsShoppingCart.sendRequest} - ${totalOrder.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            })}`)
            setEnable(true)
            setTime('')
        }, tempoTotal))

        return () => {
            timeouts.forEach(timeout => clearTimeout(timeout))
        }
    }, [restartButton])

    const takeawayOptions = getLocal('takeawayOptions', '')
    const address = getLocal('address', {})
    const deliveryMode = getLocal('deliveryMode', '')
    const totem = getLocal('totem', '')
    const payment = getSession('payment', {})
    const deliveryFee = getLocal('deliveryFee', 0)
    const totalItems = getSession('totalItems', 0)
    const discount = getSession('discount', 0)
    const discountCoupon = getSession('discountCoupon', '')
    const change = getSession('change', 0)
    const rescue = getSession('rescue', 0)
    const scheduled = getLocal('scheduled', false)
    const scheduledday = getLocal('scheduledday', false)
    const allowScheduled = (scheduled || scheduledday)
    const scheduledTime = getSession('scheduledTime', '')
    const scheduledDate = getSession('scheduledDate', '')
    const changeValue = ((change) - (((totalItems + deliveryFee) - discount) - rescue))
    const totalOrder = (((totalItems + deliveryFee) - discount) - rescue)
    const profile = getLocal('profile', {})
    const confirm = () => onClick()
    const handleClickEdit = (type) => onEdit(type)

    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        keepMounted
        PaperProps={{style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}}}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsShoppingCart.reviewInformation}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <motion.div
                initial={{x: 400}}
                animate={{x: 0}}
                transition={{duration: 0.3}}>
                <div className={'div-order-confirmation'}>
                    <div className={'div-container-confirmation'}>
                        {(!totem) &&
                            <div className={'div-data-order-address'} onClick={() => handleClickEdit('address')}>
                                <div className={'div-data-item-address'}>
                                    <div className={'div-mode'}>
                                        <label className={'label-mode'}>
                                            {(deliveryMode === 'delivery') ? textsShoppingCart.deliverTo : textsShoppingCart.takeawayTo}
                                        </label>
                                        <ExpandIcon color={'secondary'}/>
                                    </div>
                                    <label className={'description'}>
                                        {(deliveryMode === 'delivery') ? `${address.street}, ${address.number} - ${address.neighborhood}` : takeawayOptions.store}
                                    </label>
                                </div>
                            </div>}
                        <div className={'div-data-order'}>
                            <div className={'div-descriptions'}>
                                {paymentIcon(payment, totem)}
                                <div className={'descriptions'}>
                                    <label className={'title'}>
                                        {textsGeneral.payment}
                                    </label>
                                    <label className={'description'}>
                                        {(totem && payment.code === 'DIN') ? textsPaymentMethods.payCounter : payment.description}
                                    </label>
                                </div>
                            </div>
                            <div className={'button'} onClick={() => handleClickEdit('payment')}>
                                <label className={'label'}>
                                    {textsItemBag.toReplace}
                                </label>
                            </div>
                        </div>
                        {(!!cashback.balance) && <div className={'div-data-order'}>
                            <div className={'div-descriptions'}>
                                <CurrencyExchangeRounded className={'icon'}/>
                                <div className={'descriptions'}>
                                    <label className={'title'}>
                                        {textsShoppingCart.cashback}
                                    </label>
                                    <label className={'description'}>
                                        {(cashback.balance - rescue).toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}
                                    </label>
                                </div>
                            </div>
                            <div className={'button'} onClick={() => handleClickEdit('cashback')}>
                                <label className={'label'}>
                                    {(rescue) ? textsItemBag.toAlter : textsGeneral.rescue}
                                </label>
                            </div>
                        </div>}
                        <div className={'div-data-order'}>
                            <div className={'div-descriptions'}>
                                <Discount className={'icon'}/>
                                <div className={'descriptions'}>
                                    <label className={'title'}>
                                        {textsGeneral.discountCoupon}
                                    </label>
                                    <label className={'description'}>
                                        {!discountCoupon ? textsItemBag.notApplied : discountCoupon.discountCoupon}
                                    </label>
                                </div>
                            </div>
                            <div className={'button'} onClick={() => handleClickEdit('discountCoupon')}>
                                <label className={'label'}>
                                    {!discountCoupon ? textsItemBag.toAdd : textsItemBag.toReplace}
                                </label>
                            </div>
                        </div>
                        {(!totem && allowScheduled) && <div className={'div-data-order'}>
                            <div className={'div-descriptions'}>
                                <Schedule className={'icon'}/>
                                <div className={'descriptions'}>
                                    <label className={'title'}>
                                        {textsGeneral.time}
                                    </label>
                                    {(scheduledTime) ? (!!scheduledDate) ?
                                            <label className={'description'}>
                                                {`${textsShoppingCart.scheduledOrder} ${moment(scheduledDate, 'YYYY-MM-DD').format('DD/MM/YY')} ${scheduledTime.substring(0, 5)}`}
                                            </label>
                                            :
                                            <label className={'description'}>
                                                {`${textsShoppingCart.scheduledOrder} ${scheduledTime.substring(0, 5)}`}
                                            </label>
                                        :
                                        <label className={'description'}>
                                            {textsShoppingCart.immediateRequest}
                                        </label>
                                    }
                                </div>
                            </div>
                            <div className={'button'} onClick={() => handleClickEdit('scheduled')}>
                                <label className={'label'}>
                                    {textsItemBag.toReplace}
                                </label>
                            </div>
                        </div>}
                        {(!totem) && <div className={'div-data-order'}>
                            <div className={'div-descriptions'}>
                                <Receipt className={'icon'}/>
                                <div className={'descriptions'}>
                                    <label className={'title'}>
                                        {textsGeneral.cpf}
                                    </label>
                                    <label className={'description'}>
                                        {maskCPF_CNPJ(profile.cpf)}
                                    </label>
                                </div>
                            </div>
                            <div className={'button'} onClick={() => handleClickEdit('cpf')}>
                                <label className={'label'}>
                                    {textsItemBag.toReplace}
                                </label>
                            </div>
                        </div>}
                        <div className={'div-data-order-summary-values'}>
                            <div className={'div-title'}>
                                <label className={'title'}>
                                    {textsItemBag.summaryValues}
                                </label>
                            </div>
                            <div className={'div-values'}>
                                <label className={'description'}>
                                    {textsShoppingCart.subtotal}
                                </label>
                                <label className={'value'}>
                                    {totalItems.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}
                                </label>
                            </div>
                            {(!!deliveryFee) && <div className={'div-values'}>
                                <label className={'description'}>
                                    {textsShoppingCart.deliveryFee}
                                </label>
                                <label className={'value'}>
                                    {deliveryFee.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}
                                </label>
                            </div>}
                            {(discount > 0) && <div className={'div-values'}>
                                <label className={'description'}>
                                    {textsShoppingCart.discount}
                                </label>
                                <label className={'value'}>
                                    {`- ${discount.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}`}
                                </label>
                            </div>}
                            {(rescue > 0) && <div className={'div-values'}>
                                <label className={'description'}>
                                    {textsShoppingCart.cashback}
                                </label>
                                <label className={'value'}>
                                    {`- ${rescue.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}`}
                                </label>
                            </div>}
                            <div className={'div-values'}>
                                <label className={'description'} style={{fontSize: 16, fontWeight: 'bold'}}>
                                    {textsShoppingCart.total}
                                </label>
                                <label className={'description'} style={{fontSize: 16, fontWeight: 'bold'}}>
                                    {totalOrder.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}
                                </label>
                            </div>
                            {(change > 0) && <div className={'div-values'}>
                                <label className={'description'}>
                                    {textsShoppingCart.totalToPay}
                                </label>
                                <label className={'value'}>
                                    {change.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}
                                </label>
                            </div>}
                            {(changeValue > 0) && <div className={'div-values'}>
                                <label className={'description'}>
                                    {textsPaymentMethods.change}
                                </label>
                                <label className={'value'}>
                                    {changeValue.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    })}
                                </label>
                            </div>}
                        </div>
                    </div>
                </div>
            </motion.div>
        </DialogContent>
        <div className={'div-buttons-order-confirmation'}>
            <ButtonTimer
                className={'button-dialog-confirmation'}
                value={'confirm'}
                title={textoBotao}
                time={time}
                enable={enable}
                onClick={() => confirm()}
            />
        </div>
    </Dialog>
}

const paymentIcon = (payment, totem) => {
    if (payment.code === 'DIN') return (totem) ? <PointOfSaleIcon className={'icon'}/> :
        <LocalAtmIcon className={'icon-din'}/>
    else if (payment.code === 'PIX') return <Pix className={'icon-pix'}/>
    else return <CreditCardIcon className={'icon'}/>
}

export const DialogHistory = ({open, onClose, onClick}) => {
    const history = getLocal('history', [])
    const handleClick = order => onClick(order)
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsGeneral.orderHistory}
        </DialogTitle>
        <DialogContent sx={{padding: 0}}>
            <ListHistory history={history} onClick={handleClick}/>
        </DialogContent>
    </Dialog>
}

export const DialogMyOrder = ({open, order, onClose}) => {
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsGeneral.myOrder}
        </DialogTitle>
        <DialogContent sx={{padding: 0}}>
            <Order order={order}/>
        </DialogContent>
    </Dialog>
}

export const DialogServiceArea = ({open, onClose}) => {
    const serviceArea = getLocal('serviceArea', [])
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsGeneral.serviceArea}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <ServiceArea
                serviceArea={serviceArea}
            />
        </DialogContent>
    </Dialog>
}

export const DialogOpeningHours = ({open, onClose}) => {
    const weekDeliveryStore = getLocal('weekDeliveryStore', [])
    const weekShopStore = getLocal('weekShopStore', [])
    const weekDeliveryRoute = getLocal('weekDeliveryRoute', [])
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsGeneral.openingHours}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <OpeningHours
                weekDeliveryStore={weekDeliveryStore}
                weekShopStore={weekShopStore}
                weekDeliveryRoute={weekDeliveryRoute}
            />
        </DialogContent>
    </Dialog>
}

export const DialogScheduledTimes = ({open, onClick, onClose}) => {
    const handleClick = (value) => onClick(value)
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsShoppingCart.availableTimes}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <ScheduledTimes onClick={handleClick}/>
        </DialogContent>
    </Dialog>
}

export const DialogListRoute = ({open, onClick, date, routes, onClose}) => {
    const handleClick = (date, time) => onClick(date, time)
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsShoppingCart.availableTimes}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <ListRoutes date={date} routes={routes} onClick={handleClick}/>
        </DialogContent>
    </Dialog>
}

export const DialogPaymentMethods = ({open, onClose, onConfirm, onAddCard, onNext}) => {
    const {setRestartButton} = useContext(ShoppingCartContext)
    const handleClickPayment = (payment) => {
        if (payment.code === 'DIN') {
            const totem = getLocal('totem')
            if (totem) {
                setRestartButton(new Date().getTime().toString())
                setSession('payment', payment)
                onClose()
                onNext()
            } else {
                removeSession('payment')
                onConfirm()
            }
        } else if (payment.code === 'ONLINE') {
            onAddCard()
            onClose()
            onNext()
        } else {
            setRestartButton(new Date().getTime().toString())
            setSession('payment', payment)
            removeSession('change')
            onClose()
            onNext()
        }
    }

    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{
            style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}
        }}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsGeneral.paymentMethods}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <PaymentTypes onClick={handleClickPayment}/>
        </DialogContent>
    </Dialog>
}

export const DialogAddCard = ({open, onClose}) => {
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}}}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsAddCard.addCard}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <AddCard onClose={onClose}/>
        </DialogContent>
    </Dialog>
}

export const DialogAddress = ({open, onClose, onNext, onDeliveryFee}) => {
    return <Dialog
        open={open}
        onClose={onClose}
        fullScreen={isMobile()}
        PaperProps={{style: isMobile() ? {borderRadius: 0, padding: 0} : {width: 500, minHeight: '91vh'}}}>
        <DialogTitle id={'dialog-title'}>
            <ArrowBackIcon className={'icon-close'} onClick={onClose}/>
            {textsAddress.address}
        </DialogTitle>
        <DialogContent style={{padding: 0}}>
            <Address onClose={onClose} onNext={onNext} onDeliveryFee={onDeliveryFee}/>
        </DialogContent>
    </Dialog>
}
